import 'classlist-polyfill'; // IE11 doesn't support all features of classlist such as 2nd param of toggle()

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

import { VBrickPlayer360PluginModule } from '../threeSixty/VBrickPlayer360Plugin.Module';
import { VgConferenceDualHlsModule } from '../hls/dual/VgConferenceDualHls.Module';
import { VbHotkeysModule } from './hotkeys/VbHotkeys.Module';
import { VgHlsModule } from '../hls/VgHls.Module';
import { PipesModule } from './pipes/Pipes.Module';
import { SharedModule } from './shared/Shared.Module';
import { VgPosterModule } from './videogular/poster/VgPoster.Module';
import { VideogularModule } from './videogular/Videogular.Module';
import { VideogularControlsModule } from './videogular/controls/VideogularControls.Module';

import { CurrentStateClassDirective } from './CurrentStateClass.Directive';
import { HlsLevelPickerComponent } from './HlsLevelPicker.Component';
import { InitialBufferingManagerComponent } from './InitialBufferingManager.Component';
import { VBrickPlayerComponent } from './VbrickPlayer.Component';
import { VbAudioMenuComponent } from './VbAudioMenu.Component';
import { VbNoSupportedPlaybacksComponent } from './VbNoSupportedPlaybacks.Component';
import { VbOverlayBufferingComponent } from './VbOverlayBuffering.Component';
import { VbOverlayBufferingManagerComponent } from './VbOverlayBufferingManager.Component';
import { VbOverlayPlayControlsComponent } from './VbOverlayPlayControls.Component';
import { VbOverlayVideoVerificationComponent } from './VbOverlayVideoVerification.Component';
import { VbPlaybackManagerComponent } from './VbPlaybackManager.Component';
import { VbPlaybackMenuButtonComponent } from './VbPlaybackMenuButton.Component';
import { VbPlaybackRateButtonComponent } from './VbPlaybackRateButton.Component';
import { VbPlaybackUnavailableComponent } from './VbPlaybackUnavailable.Component';
import { VbPlayerjsReceiverComponent } from './VbPlayerjsReceiver.Component';
import { VbStartAtManagerComponent } from './VbStartAtManager.Component';
import { VbSubtitleDisplayComponent } from './VbSubtitleDisplay.Component';
import { VbSubtitleMenuButtonComponent } from './VbSubtitleMenuButton.Component';
import { VbPlayerSettingsMenuComponent } from './VbPlayerSettingsMenu.Component';


import { ClosedCaptionsUtilService } from './ClosedCaptionsUtil.Service';
import { HlsUtilService } from './HlsUtil.Service';
import { NativePlaybackUtilService } from './NativePlaybackUtil.Service';
import { PlayerSizeDetectionService } from './PlayerSizeDetection.Service';
import { ReactionsMenuComponent } from './reactions/ReactionsMenu.Component';
import { ReactionsPlayerComponent } from './reactions/ReactionsPlayer.Component';
import { SubtitleService } from './Subtitle.Service';
import { SupportedPlaybacksService } from './SupportedPlaybacks.Service';
import { TextTrackHelperService } from './TextTrackHelper.Service';
import { VbC2PAComponent } from './c2pa/VbC2PA.Component';
import { getVbPlaybackToken, VbPlaybackToken } from './VbPlaybackToken.Provider';

const components = [
	HlsLevelPickerComponent,
	InitialBufferingManagerComponent,
	VbAudioMenuComponent,
	VbNoSupportedPlaybacksComponent,
	VbOverlayBufferingComponent,
	VbOverlayBufferingManagerComponent,
	VbOverlayPlayControlsComponent,
	VbOverlayVideoVerificationComponent,
	VbPlaybackManagerComponent,
	VbPlaybackMenuButtonComponent,
	VbPlaybackRateButtonComponent,
	VbPlaybackUnavailableComponent,
	VbPlayerjsReceiverComponent,
	VbPlayerSettingsMenuComponent,
	VBrickPlayerComponent,
	VbStartAtManagerComponent,
	VbSubtitleDisplayComponent,
	VbSubtitleMenuButtonComponent,
	ReactionsMenuComponent,
	ReactionsPlayerComponent
];

const directives = [
	CurrentStateClassDirective
];

@NgModule({
	declarations: [...components, ...directives],
	exports: [VBrickPlayerComponent],
	imports: [
		BsDropdownModule,
		CommonModule,
		FormsModule,
		PipesModule,
		SharedModule,
		TooltipModule,
		VBrickPlayer360PluginModule,
		VbC2PAComponent,
		VbHotkeysModule,
		VgConferenceDualHlsModule,
		VgHlsModule,
		VgPosterModule,
		VideogularControlsModule,
		VideogularModule,
	],
	providers: [
		ClosedCaptionsUtilService,
		HlsUtilService,
		NativePlaybackUtilService,
		PlayerSizeDetectionService,
		SubtitleService,
		SupportedPlaybacksService,
		TextTrackHelperService,
		{
			deps: [
				HttpClient
			],
			provide: VbPlaybackToken,
			useFactory: getVbPlaybackToken
		}
	],
	schemas: [
		CUSTOM_ELEMENTS_SCHEMA
	]
})
export class VbrickPlayerModule {}
